// extracted by mini-css-extract-plugin
export var activityContainer = "_me-0";
export var typingIndicatorContainer = "_me-1";
export var typingIndicatorDot = "_me-2";
export var wave = "_me-3";